// Copies the chosen preset or Other amount into the hidden `amount` field that both Stripe
// payment fields mount against (Formie needs a non-zero amount and re-mounts on `input`).
// The server derives the charge from the same two fields on submit regardless.

const AMOUNT_INPUT_SELECTOR = 'input[name$="[amount]"]';
const PRESET_INPUT_SELECTOR = 'input[name$="[preset]"]';
const OTHER_INPUT_SELECTOR = 'input[name$="[otherAmount]"]';
const PRESET_OTHER = 'other';

const init = (wrapper) => {
    const amountInput = wrapper.querySelector(AMOUNT_INPUT_SELECTOR);
    const otherInput = wrapper.querySelector(OTHER_INPUT_SELECTOR);

    if (!amountInput) {
        return;
    }

    const refresh = () => {
        const preset = wrapper.querySelector(`${PRESET_INPUT_SELECTOR}:checked`)?.value;
        const chosen = preset === PRESET_OTHER ? otherInput?.value : preset;
        const amount = parseFloat(chosen);
        const value = amount > 0 ? amount.toFixed(2) : '';

        if (amountInput.value !== value) {
            amountInput.value = value;
            amountInput.dispatchEvent(new Event('input', { bubbles: true }));
        }
    };

    wrapper.addEventListener('change', refresh);
    wrapper.addEventListener('input', (event) => {
        if (event.target !== amountInput) {
            refresh();
        }
    });

    refresh();
};

// Called from the Vue root's mounted hook: Vue re-renders everything inside #app from
// its DOM template on mount, so anything grabbed earlier is a detached node.
export const initDonateAmount = () => document.querySelectorAll('[data-donate-amount]').forEach(init);
